
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyAmmonia as ObiEnergyAmmoniaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-ammonia.js';
 
 
 

 
 export const ObiEnergyAmmonia = createComponent({
   react: React,
   tagName: 'obi-energy-ammonia',
   elementClass: ObiEnergyAmmoniaElement,
   events: {
     
   }
  });
 
 